export default {
  REFRESH_TOKEN: 'ermes_bo_refreshToken',
  ACCESS_TOKEN: 'ermes_bo_accessToken',
  ADMIN_TOKEN: 'ermes_bo_adminToken',
  EXPIRE_AT: 'ermes_bo_expireAt'
};
